export default "__VITE_ASSET__CK6BULEi__"